import { GlIcon, GlTooltipDirective } from '@gitlab/ui';
import { translate } from '@gitlab/ui/dist/utils/i18n';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  CHAT_VERIFIED_AGENT: translate('DuoChat.verifiedAgent', 'Created and maintained by GitLab')
};
var script = {
  name: 'ChatAgentItem',
  components: {
    GlIcon
  },
  directives: {
    GlTooltip: GlTooltipDirective
  },
  props: {
    agent: {
      type: Object,
      required: true
    }
  },
  i18n
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"gl-flex gl-flex-col"},[_c('span',{staticClass:"gl-mb-1 gl-inline-block gl-text-lg gl-font-bold gl-text-strong"},[_vm._v("\n    "+_vm._s(_vm.agent.name)+"\n    "),(_vm.agent.foundational)?_c('gl-icon',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"name":"tanuki-verified","variant":"subtle","title":_vm.$options.i18n.CHAT_VERIFIED_AGENT}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"gl-overflow-hidden gl-text-ellipsis gl-whitespace-nowrap gl-text-sm"},[_vm._v("\n    "+_vm._s(_vm.agent.description)+"\n  ")])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
export { i18n };
